import { type Language } from "@/contexts/LanguageContext";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/lib/brand";
import { buildLocalizedPath } from "@/lib/i18n";

export type AppPlatform = "ios" | "android" | "desktop";

export const detectAppPlatform = (
  device: Pick<Navigator, "userAgent" | "maxTouchPoints"> | undefined =
    typeof navigator === "undefined" ? undefined : navigator,
): AppPlatform => {
  if (!device) return "desktop";
  if (/iPad|iPhone|iPod/.test(device.userAgent)) return "ios";
  if (/Macintosh/.test(device.userAgent) && device.maxTouchPoints > 1) return "ios";
  if (/android/i.test(device.userAgent)) return "android";
  return "desktop";
};

export const appStoreUrl = (platform: Exclude<AppPlatform, "desktop">) =>
  platform === "ios" ? APP_STORE_URL : PLAY_STORE_URL;

const DOWNLOAD_SOURCES = new Set([
  "nav", "home_hero", "app_hero", "home_voice_demo", "app_voice_demo",
  "home_download", "app_download", "home_features", "app_features",
  "home_free_start", "app_free_start", "queen_teaser", "field_download",
  "qr_redirect", "product_waitlist", "scale_story", "product_detail",
  "guide_article", "home_workflow", "app_workflow", "home_ai", "app_ai",
]);

/** Only known placements enter analytics or survive the QR redirect. */
export const appDownloadSource = (source: string | null) =>
  source && DOWNLOAD_SOURCES.has(source) ? source : "qr_redirect";

export const appDownloadQrUrl = (language: Language, source: string) =>
  "https://www.fluxabee.com" + buildLocalizedPath("/download", language) +
  "?source=" + appDownloadSource(source);
